module.exports = __webpack_public_path__ + "img/category-1.a87d91d5.svg";